import React from 'react';
import { Button } from './ui/button';
import { Calendar, MessageCircle } from 'lucide-react';
import { howItWorks, businessInfo } from '../data/mock';
import { trackBooking, trackWhatsApp } from '../lib/analytics';

const HowItWorks = () => {
  const handleBooking = () => {
    trackBooking('how_it_works');
    window.open(businessInfo.bookingUrl, '_blank');
  };

  const handleWhatsApp = () => {
    trackWhatsApp('how_it_works');
    const url = `https://wa.me/${businessInfo.phone}?text=${encodeURIComponent(businessInfo.whatsappMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <section className="py-20 bg-transparent" data-testid="how-it-works-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-semibold">Simples e rápido</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-4">
            Como <span className="text-[#D4AF37]">funciona</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Em três passos você garante sua experiência premium na ABR Barbearia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent"></div>

          {howItWorks.map((item, index) => (
            <div
              key={item.id}
              data-testid={`step-${item.id}`}
              className="relative text-center group"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="relative mx-auto w-32 h-32 mb-6">
                <div className="absolute inset-0 rounded-full bg-[#D4AF37]/5 border border-[#D4AF37]/30 group-hover:bg-[#D4AF37]/20 group-hover:scale-110 transition-all duration-500"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-5xl font-bold text-[#D4AF37]">{item.step}</span>
                </div>
              </div>
              <h3 className="text-white text-2xl font-bold mb-3">{item.title}</h3>
              <p className="text-gray-400 leading-relaxed max-w-xs mx-auto">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-16">
          <Button
            onClick={handleBooking}
            data-testid="how-it-works-booking-btn"
            size="lg"
            className="bg-[#D4AF37] hover:bg-[#B8941F] text-black font-semibold rounded-sm px-8 py-6 transition-all duration-300 hover:scale-105"
          >
            <Calendar className="mr-2 h-5 w-5" />
            Agendar pelo Gendo
          </Button>
          <Button
            onClick={handleWhatsApp}
            data-testid="how-it-works-whatsapp-btn"
            variant="outline"
            size="lg"
            className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black rounded-sm px-8 py-6"
          >
            <MessageCircle className="mr-2 h-5 w-5" />
            Falar no WhatsApp
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
